enum AddressResponseCode {
  Ok = '0',
  InvalidPostcode1 = '21',
  InvalidPostcode2 = '22',
}

export default AddressResponseCode;
